"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.TableLayout = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTable = require("react-table");

var _hooks = require("../../hooks");

var _ = require("./..");

var TableLayout = {
  CARD: 'card',
  DEFAULT: 'default'
};
exports.TableLayout = TableLayout;

var NextButton = function NextButton(props) {
  var other = (0, _extends2.default)({}, props);
  return /*#__PURE__*/_react.default.createElement(_.IconButton, (0, _extends2.default)({}, other, {
    icon: "fas fa-arrow-right",
    variant: "outline"
  }));
};

var PrevButton = function PrevButton(props) {
  var other = (0, _extends2.default)({}, props);
  return /*#__PURE__*/_react.default.createElement(_.IconButton, (0, _extends2.default)({}, other, {
    icon: "fas fa-arrow-left",
    variant: "outline"
  }));
};

var mapCardColumns = function mapCardColumns(_ref) {
  var CardCell = _ref.CardCell,
      Cell = _ref.Cell,
      columns = _ref.columns,
      column = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["CardCell", "Cell", "columns"]);
  return (0, _extends2.default)({}, column, {
    columns: columns && columns.map(mapCardColumns),
    Cell: CardCell || Cell
  });
};

var ReactTable = function ReactTable(props) {
  var _useClassNames = (0, _hooks.useClassNames)(props),
      className = _useClassNames.className,
      classNames = _useClassNames.classNames,
      layout = _useClassNames.layout,
      columns = _useClassNames.columns,
      data = _useClassNames.data,
      loading = _useClassNames.loading,
      pagination = _useClassNames.pagination,
      fetchData = _useClassNames.fetchData,
      pageSizeOptions = _useClassNames.pageSizeOptions,
      showPageSizeOptions = _useClassNames.showPageSizeOptions,
      other = (0, _objectWithoutPropertiesLoose2.default)(_useClassNames, ["className", "classNames", "layout", "columns", "data", "loading", "pagination", "fetchData", "pageSizeOptions", "showPageSizeOptions"]);

  var tableColumns = (0, _react.useMemo)(function () {
    if (layout === TableLayout.CARD) {
      return columns.map(mapCardColumns);
    }

    return columns;
  }, [columns, layout]);
  var tableInstance = (0, _reactTable.useTable)((0, _extends2.default)({
    columns: tableColumns,
    data: data,
    manualPagination: true,
    pageCount: pagination.totalPages,
    initialState: {
      pageIndex: pagination.page - 1,
      pageSize: pagination.pageSize
    }
  }, other), _reactTable.usePagination);
  var getTableProps = tableInstance.getTableProps,
      getTableBodyProps = tableInstance.getTableBodyProps,
      headerGroups = tableInstance.headerGroups,
      page = tableInstance.page,
      gotoPage = tableInstance.gotoPage,
      nextPage = tableInstance.nextPage,
      canNextPage = tableInstance.canNextPage,
      previousPage = tableInstance.previousPage,
      canPreviousPage = tableInstance.canPreviousPage,
      setPageSize = tableInstance.setPageSize,
      prepareRow = tableInstance.prepareRow,
      _tableInstance$state = tableInstance.state,
      pageIndex = _tableInstance$state.pageIndex,
      pageSize = _tableInstance$state.pageSize;
  var fetchDataRef = (0, _react.useRef)(fetchData);
  (0, _react.useEffect)(function () {
    fetchDataRef.current = fetchData;
  }, [fetchData]);
  (0, _react.useEffect)(function () {
    fetchDataRef.current({
      pageIndex: pageIndex,
      pageSize: pageSize
    });
  }, [pageIndex, pageSize]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (classNames([{
      layout: layout
    }]) + " " + className).trim()
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, getTableProps(), {
    className: "rt-table"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "rt-thead -header"
  }, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, headerGroup.getHeaderGroupProps(), {
      className: "rt-tr"
    }), headerGroup.headers.map(function (column) {
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, column.getHeaderProps(), {
        className: "rt-th rt-resizable-header"
      }), /*#__PURE__*/_react.default.createElement("span", null, column.render('Header')));
    }));
  })), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, getTableBodyProps(), {
    className: "rt-tbody"
  }), page.map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, row.getRowProps(), {
      className: "rt-tr-group"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "rt-tr " + (i % 2 === 0 ? '-even' : '-odd')
    }, row.cells.map(function (cell) {
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, cell.getCellProps(), {
        className: "rt-td"
      }), cell.render('Cell'));
    })));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pagination-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "-pagination"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "-previous"
  }, /*#__PURE__*/_react.default.createElement(PrevButton, {
    onClick: function onClick() {
      return previousPage();
    },
    disabled: !canPreviousPage
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "-center"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "-pageInfo"
  }, "P\xE1gina", ' ', /*#__PURE__*/_react.default.createElement("div", {
    className: "-pageJump"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "number",
    min: 1,
    max: pagination.totalPages,
    value: pageIndex + 1,
    onChange: function onChange(e) {
      var page = e.target.value ? Number(e.target.value) - 1 : 0;
      gotoPage(page);
    },
    style: {
      width: '100px'
    }
  })), "de", /*#__PURE__*/_react.default.createElement("span", {
    className: "-totalPages"
  }, pagination.totalPages)), showPageSizeOptions && /*#__PURE__*/_react.default.createElement("span", {
    className: "select-wrap -pageSizeOptions"
  }, /*#__PURE__*/_react.default.createElement("select", {
    "aria-label": "rows per page",
    value: pageSize,
    onChange: function onChange(e) {
      setPageSize(Number(e.target.value));
    }
  }, pageSizeOptions.map(function (pageSize) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: pageSize,
      value: pageSize
    }, "Mostrar ", pageSize);
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "-next"
  }, /*#__PURE__*/_react.default.createElement(NextButton, {
    onClick: function onClick() {
      return nextPage();
    },
    disabled: !canNextPage
  })))));
};

ReactTable.propTypes = {
  className: _propTypes.default.string,
  layout: _propTypes.default.oneOfType([_propTypes.default.oneOf(Object.values(TableLayout)), _propTypes.default.string])
};
ReactTable.defaultProps = {
  alias: 'ReactTable',
  className: '',
  layout: TableLayout.DEFAULT,
  pagination: {
    pageSize: 10,
    page: 1,
    totalPages: 0
  }
};
ReactTable.displayName = 'ReactTable';
var _default = ReactTable;
exports.default = _default;